import { TableCell } from "@mui/material"

export function RegimeTableExtraCell({ column }) {
    return (
        <TableCell align={column.align} data-cy={`regime-row-${column.field}`}>
            {column.cell}
        </TableCell>
    )
}
